import { combineReducers } from "redux";
import { createMigrate, persistReducer } from 'redux-persist'
import localStorage from "redux-persist/lib/storage";

import AuthReducer from "./AuthReducer";
import ItemsReducer from "./ItemsReducer";
import SettingsReducer from "./SettingsReducer";
import FiltersReducer from "./FiltersReducer";
import ActivityReducer from "./ActivityReducer";
import WishListReducer from "./WishListReducer";
import SubscriptionsReducer from "./SubscriptionReducer";
import { APIManager } from "../utils/api";
import APIUrls from "../constants/ApiUrls";

const migrations = {
  // migrate tenant to fetch new tenant with algolia search key
  0: async (state) => {
    let tenant = state.tenant;
    if (state.cognitoUser.attributes.email) {
      const data = await APIManager.Instance.call("GET", APIUrls.getTenant(state.cognitoUser.attributes.email));
      tenant = data.tenant;
    }
    return {
      ...state,
      tenant
    }
  },
}

const authPersistConfig = {
  key: 'auth',
  version: 1,
  storage: localStorage,
  blacklist: ['Auth', 'Analytics'],
  migrate: createMigrate(migrations, { debug: false })
}

// const RootReducer = combineReducers({  
const AppReducer = combineReducers({
  auth: persistReducer(authPersistConfig, AuthReducer),
  item: ItemsReducer,
  settings: SettingsReducer,
  filters: FiltersReducer,
  activity: ActivityReducer,
  wishlist: WishListReducer,
  subscriptions:SubscriptionsReducer
});

const RootReducer = (state, action) => {
  // let newState = {};
  // let newAction = null;
  if (action.type === 'USER_LOGOUT') {
  //   console.log('action for root: ', action.type);
  //   // remove persist values
  //   // localStorage.removeItem('persist:root');
  //   // localStorage.removeItem('persist:auth');
    
  //   newState = {};
  //   newAction = null;
  // } else {
  //   newState = state;
  //   newAction = action;
  }
  // delegate to combined reducers
  return AppReducer(state, action);
}

export default RootReducer;
